import type { ClientGPSLocation } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useSharedAppApi } from '@/features/api/hooks/shared-app/useSharedAppApi';
import type { Kilometers } from '@/features/api/types/map';
import { NULL_GPS_LOCATION } from '@/features/geo-area/constants/gps';

export const useGetNearestGeoAreas = (
  center: ClientGPSLocation = NULL_GPS_LOCATION,
  radius: Kilometers
) => {
  const api = useSharedAppApi();
  return useQuery({
    queryKey: [API_CACHE_KEYS.AVAILABLE_GEO_AREAS, { center, radius }],
    queryFn: () =>
      api.getNearestAvailableGeoAreasForAppVariant({
        latitude: center.latitude,
        longitude: center.longitude,
        radiusKM: radius
      }),
    enabled: center !== NULL_GPS_LOCATION
  });
};
